import { useState, useEffect } from "react";
import ReactMarkdown from "react-markdown";
import rehypeRaw from "rehype-raw";
import rehypeKatex from "rehype-katex";
import remarkMath from "remark-math";
import remarkGfm from "remark-gfm";
import { Container, Row, Col } from "react-bootstrap";
import "katex/dist/katex.min.css";
import "./styles/BlogMarkdown.scss";
import { useParams } from "react-router-dom";
import { Prism as SyntaxHighlighter } from "react-syntax-highlighter";
import { oneDark } from "react-syntax-highlighter/dist/esm/styles/prism";

export default function BlogMarkdown() {
  const id = useParams().id; // this is the dirname
  const blogPath = `${process.env.PUBLIC_URL}/assets/markdown_blogs/${id}/content.md`;
  const [isLoading, setLoading] = useState(true);
  const [markdown, setMarkdown] = useState("");
  const [isError, setError] = useState(false);

  function doesBlogFileExist(responseString) {
    // this check works because the fetch api returns the index.html when the blog doesn't exist, idk why.
    // All blogs has <!-- title start --> tag, so when that thing isn't there then the blog file didn't get
    // fetched and instead we grabbed the index.html
    if (responseString.includes("<!-- title start -->")) {
      return true;
    }
  }

  const loadFile = async () => {
    setLoading(true);
    try {
      let mdString = await fetch(blogPath);
      mdString = await mdString.text();
      //I need this check because the thing renders index.html when I pass a blog id that doesnt exist
      if (doesBlogFileExist(mdString)) {
        setMarkdown(mdString);
      } else {
        setError(true);
      }
      setLoading(false);
    } catch (error) {
      alert("An error has occurred, please go back and try again");
      // setError(true);
      console.log("ERRR");
    }
  };

  useEffect(() => {
    loadFile();
  }, []);

  return (
    <div id="mdBlog">
      {isError ? (
        <div>
          An Error has occurred check url, or navigate to the required page from
          the home page
        </div>
      ) : null}
      {isLoading ? (
        <div>Loading...</div>
      ) : (
        <Container>
          <Row className="my-5">
            <Col>
              <ReactMarkdown
                rehypePlugins={[rehypeRaw, rehypeKatex]}
                remarkPlugins={[remarkMath, remarkGfm]}
                components={{
                  code({ node, inline, className, children, ...props }) {
                    const match = /language-(\w+)/.exec(className || "");
                    return !inline && match ? (
                      <SyntaxHighlighter
                        style={oneDark}
                        language={match[1]}
                        PreTag="div"
                        {...props}
                      >
                        {String(children).replace(/\n$/, "")}
                      </SyntaxHighlighter>
                    ) : (
                      <code className={className} {...props}>
                        {children}
                      </code>
                    );
                  },
                }}
              >
                {markdown}
              </ReactMarkdown>
            </Col>
          </Row>
        </Container>
      )}
    </div>
  );
}
